module.exports = __webpack_public_path__ + "static/img/3.26288815.jpeg";